module.exports = __webpack_public_path__ + "img/ISO20000.86ff75b8.jpg";